/* Green2bean — motion + interaction, ported to Shopify.
   Signature moment: pinned 4-step brew scrub.
   Supporting: variant world-swap, staggered reveals, parallax, offer marquee (CSS).
   Progressive enhancement: the page is fully readable and shoppable with JS off —
   the buy box is a real <form action="/cart/add"> and the club form is a Shopify
   customer form, so both work without this file.
   Re-runs on shopify:section:load so the Theme Editor stays live. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- currency ---------- */
  function money(cents) {
    var fmt = (window.G2B && window.G2B.moneyFormat) || '£{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      var v = cents / 100;
      if (name === 'amount_no_decimals') return Math.round(v).toLocaleString('en-GB');
      return v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* ---------- cart count ---------- */
  function paintCart(n) {
    $$('[data-g2b-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.add('pop');
      setTimeout(function () { el.classList.remove('pop'); }, 320);
    });
  }
  function loadCart() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCart(c.item_count); })
      .catch(function () {});
  }

  /* ---------- reveals ---------- */
  function initReveals(root) {
    var nodes = $$('.rv:not(.in)', root);
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || reduce) { nodes.forEach(function (n) { n.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sibs = $$(':scope > .rv', e.target.parentNode);
        e.target.style.transitionDelay = (Math.min(Math.max(sibs.indexOf(e.target), 0), 4) * 0.09) + 's';
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- signature: pinned brew scrub ---------- */
  var pins = [];
  function initBrew(root) {
    $$('[data-g2b-brew]', root).forEach(function (sec) {
      var track = $('[data-brew-track]', sec), stage = $('[data-brew-stage]', sec), bar = $('[data-brew-bar]', sec);
      if (!track || !stage) return;
      var shots = $$('img', stage), steps = $$('[data-brew-steps] > li', sec);
      if (!steps.length) return;
      var p = { track: track, bar: bar, shots: shots, steps: steps, pinned: false, last: -1 };
      pins.push(p);
      setupPin(p);
    });
  }
  function setupPin(p) {
    var wide = window.innerWidth > 1000;
    if (wide && !p.pinned) { p.track.style.height = (p.steps.length * 62) + 'vh'; p.pinned = true; }
    else if (!wide && p.pinned) { p.track.style.height = ''; p.pinned = false; }
    if (!wide) {
      p.shots.forEach(function (s, i) { s.classList.toggle('on', i === 0); });
      p.steps.forEach(function (s) { s.classList.add('on'); });
    }
  }
  function scrub(p) {
    if (!p.pinned) return;
    var r = p.track.getBoundingClientRect();
    var span = r.height - window.innerHeight;
    if (span <= 0) return;
    var prog = Math.min(1, Math.max(0, -r.top / span));
    if (p.bar) p.bar.style.width = (prog * 100).toFixed(2) + '%';
    var i = Math.min(p.steps.length - 1, Math.floor(prog * p.steps.length * 0.999));
    if (i === p.last) return;
    p.last = i;
    p.shots.forEach(function (s, n) { s.classList.toggle('on', n === i); });
    p.steps.forEach(function (s, n) { s.classList.toggle('on', n === i); });
  }

  /* ---------- parallax ---------- */
  function parallax() {
    $$('[data-parallax], img.g2b-parallax').forEach(function (el) {
      var r = el.parentNode.getBoundingClientRect();
      if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
      var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translate3d(0,' + (-p * 7).toFixed(2) + '%,0)';
    });
  }

  var ticking = false;
  function frame() { pins.forEach(scrub); if (!reduce) parallax(); ticking = false; }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  addEventListener('resize', function () { pins.forEach(function (p) { setupPin(p); p.last = -1; }); frame(); });

  /* ---------- header: mobile nav ---------- */
  function initHeader(root) {
    $$('[data-g2b-header]', root).forEach(function (h) {
      var burger = $('[data-burger]', h), nav = $('[data-nav]', h);
      if (!burger || !nav || burger.dataset.bound) return;
      burger.dataset.bound = '1';
      burger.addEventListener('click', function () {
        var open = nav.classList.toggle('open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      $$('a', nav).forEach(function (a) {
        a.addEventListener('click', function () { nav.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); });
      });
    });
  }

  /* ---------- buy box: variant world-swap, qty, add to cart ---------- */
  function initBuy(root) {
    $$('[data-g2b-buy]', root).forEach(function (buy) {
      var form = $('form[action*="/cart/add"]', buy);
      var idInput = form ? $('[name="id"]', form) : null;
      var qtyInput = form ? $('[name="quantity"]', form) : null;
      var figs = $$('[data-buy-fig] img', buy);
      var swatches = $$('[data-swatch]', buy);
      var priceEl = $('[data-buy-price]', buy);
      var totalEl = $('[data-add-total]', buy);
      var qVal = $('[data-qty-val]', buy);
      var addBtn = form ? $('[type="submit"]', form) : null;
      var data = {};
      var json = $('[data-variant-json]', buy);
      if (json) { try { data = JSON.parse(json.textContent); } catch (e) { data = {}; } }
      var current = idInput ? String(idInput.value) : null;
      var q = 1;

      function sync() {
        var v = data[current];
        if (qVal) qVal.textContent = q;
        if (qtyInput) qtyInput.value = q;
        if (v) {
          if (priceEl) priceEl.textContent = money(v.price);
          if (totalEl) totalEl.textContent = money(v.price * q);
          if (addBtn) {
            addBtn.disabled = !v.available;
            var lbl = $('[data-add-label]', addBtn);
            if (lbl) lbl.textContent = v.available ? (addBtn.dataset.labelAdd || 'Add to cart') : (addBtn.dataset.labelSold || 'Sold out');
          }
        }
      }
      function pick(id) {
        current = String(id);
        if (idInput) idInput.value = current;
        figs.forEach(function (f) { f.classList.toggle('on', f.dataset.vid === current); });
        swatches.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.vid === current ? 'true' : 'false'); });
        sync();
      }
      swatches.forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.vid); }); });
      var minus = $('[data-qty-minus]', buy), plus = $('[data-qty-plus]', buy);
      if (minus) minus.addEventListener('click', function () { q = Math.max(1, q - 1); sync(); });
      if (plus) plus.addEventListener('click', function () { q = Math.min(20, q + 1); sync(); });
      sync();

      /* cross-section selection: blend cards deep-link into the buy box */
      $$('[data-pick-vid]').forEach(function (a) {
        a.addEventListener('click', function () { pick(a.dataset.pickVid); });
      });

      /* real add to cart, with the fly-to-cart micro-moment */
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return; /* no JS cart: let the form post normally */
          e.preventDefault();
          var src = $('[data-buy-fig] img.on', buy);
          var cartBtn = $('[data-g2b-cart-link]');
          if (src && cartBtn && !reduce) {
            var r = src.getBoundingClientRect(), t = cartBtn.getBoundingClientRect(), fly = document.createElement('img');
            fly.src = src.currentSrc || src.src; fly.className = 'fly'; fly.alt = '';
            fly.style.left = (r.left + r.width / 2 - 27) + 'px';
            fly.style.top = (r.top + r.height / 2 - 27) + 'px';
            document.body.appendChild(fly);
            requestAnimationFrame(function () {
              fly.style.transition = 'transform .72s cubic-bezier(.4,0,.2,1),opacity .72s ease';
              fly.style.transform = 'translate(' + (t.left + t.width / 2 - (r.left + r.width / 2)) + 'px,' +
                (t.top + t.height / 2 - (r.top + r.height / 2)) + 'px) scale(.22)';
              fly.style.opacity = '0';
            });
            setTimeout(function () { fly.remove(); }, 780);
          }
          if (addBtn) addBtn.classList.add('is-loading');
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(current), quantity: q }] })
          }).then(function (r) { return r.json(); })
            .then(function (res) {
              if (addBtn) addBtn.classList.remove('is-loading');
              if (res.status) { form.submit(); return; } /* error → fall back to a full post */
              var err = $('[data-buy-error]', buy);
              if (err) err.textContent = '';
              return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (c) { setTimeout(function () { paintCart(c.item_count); }, reduce ? 0 : 520); });
            })
            .catch(function () { if (addBtn) addBtn.classList.remove('is-loading'); form.submit(); });
        });
      }
    });
  }

  function boot(root) {
    initReveals(root); initHeader(root); initBuy(root); initBrew(root);
    frame();
  }
  document.addEventListener('DOMContentLoaded', function () { boot(document); loadCart(); });
  if (document.readyState !== 'loading') { boot(document); loadCart(); }
  document.addEventListener('shopify:section:load', function (e) { pins = []; boot(e.target); });
})();
